// A character's icon from the script sheet (client/scripts/extract_role_icons.py). Each file is a
// mask filled with the colour of the text around it, so an icon takes the app's good and evil
// colours rather than the sheet's print ones, which are too dark on this background.
//
// It is an empty span, not an <img>: the role card is pressed and held, and a long press on an
// image opens iOS's "Save image" menu. With no text, it leaves every label and name as it was.
//
// An icon is readable from across the table where text is not, so icons go only where roles are
// public (the character list, the game-over grimoire) or behind HoldToReveal (your role card).
// Night prompts and the notebook stay text only.

// ?no-inline: every icon is its own file, precached by the service worker (vite.config.ts),
// rather than some of them inlined into the bundle every page loads
const FILES = import.meta.glob<string>("../assets/roles/*.png", {
  eager: true,
  import: "default",
  query: "?no-inline",
});

const ICONS: Record<string, string> = Object.fromEntries(
  Object.entries(FILES).map(([path, url]) => [path.slice(path.lastIndexOf("/") + 1, -4), url]),
);

/** The icon for this role id, `width` px wide, or nothing when the script sheet has none. */
export function RoleIcon({
  roleId,
  width,
  className,
}: {
  roleId: string;
  width: number;
  className?: string;
}) {
  const url = ICONS[roleId];
  if (!url) return null;
  const mask = `url("${url}")`;
  return (
    <span
      className={className ? `role-icon ${className}` : "role-icon"}
      aria-hidden
      style={{ width, WebkitMaskImage: mask, maskImage: mask }}
    />
  );
}
